import Slides from "./scripts/slides"
import GoogleMap from "./scripts/googleMap";
import SampleDropDown from "./scripts/sampleDropDown";
import Categories from "./scripts/Categories";
import GetDirection from "./scripts/getDirection";
import JumpToSearchResult from "./scripts/jumpToSearchResult";
import CallBannerHeader from "./scripts/callBannerHeader";

Slides();
GoogleMap();
SampleDropDown();
Categories();
GetDirection();
JumpToSearchResult();
CallBannerHeader();